// Pixeles de publicidad de la pagina publica: Meta (Facebook / Instagram) y TikTok.
//
//  - Pixeles GENERALES de Meta y de TikTok (Ajustes > Pixeles): reciben todo el sitio.
//  - Pixeles POR CONCIERTO (Ajustes > Pixeles > "Pixeles por concierto"): el pixel de Meta o de TikTok de un
//    organizador recibe SOLO lo de su concierto (visita a su pagina, ver el evento, pasar a pagar, metodo de pago,
//    orden registrada). Se envia con trackSingle / ttq.instance(id), asi un pixel nunca recibe lo de otro.
//  - La pagina pregunta que pixeles hay a /api/v1/meta/config: se activan o cambian desde Ajustes, sin
//    volver a compilar el front. Sin nada configurado no se carga ningun script.
//
// Reglas (manejo de datos):
//  - Solo carga si el cliente ACEPTO las cookies de analitica y publicidad en el banner (tickets_cookies_consent).
//    Si despues las rechaza, se le dice a Meta y a TikTok que no usen mas sus datos.
//  - Nunca en el panel (/admin, /auth) ni con una sesion del panel abierta (admin / vendedor):
//    las ventas del personal no son compras de anuncios.
//  - Solo los eventos de este archivo: se apaga la configuracion automatica de Meta (autoConfig), que por
//    defecto registra clics en botones y datos de la pagina por su cuenta.
//  - La COMPRA PAGADA (Meta "Purchase", TikTok "CompletePayment") se avisa de dos formas, con el mismo id
//    ("compra-<id>") para que Meta y TikTok la cuenten UNA sola vez:
//      1) Desde aqui, si se confirma mientras el cliente sigue en la pagina (tarjeta pagada rapido, transferencia
//         aprobada por el OCR o por un admin rapido): vigilarPagoCompra consulta el estado cada 15 s los primeros
//         5 minutos y luego cada 60 s, hasta 30 minutos, solo con la pestana visible.
//      2) Desde el backend con el token (API de Conversiones / Events API), aunque el cliente ya haya cerrado la
//         pagina, con los datos que se guardan al crear la compra (datosCompraMeta).
//  - Nada de esto puede romper la pagina: cada funcion atrapa sus errores.
import { AxioBoleteria } from "./index";
import { clienteInfo } from "./DatosUsuarioLocalStorag";

// Misma clave que views/Components/Cookies (no se importa de ahi para no traer un componente a utils)
const CLAVE_CONSENTIMIENTO = "tickets_cookies_consent";
const CLAVE_FBCLID = "meta_fbclid";
const ID_META = /^\d{5,25}$/;
const ID_TIKTOK = /^[A-Za-z0-9]{10,40}$/;

const estado = { config: null, metaListo: false, metaIniciados: new Set(), tiktokIniciados: new Set(), iniciado: false };

const consentimiento = () => {
    try { return (JSON.parse(localStorage.getItem(CLAVE_CONSENTIMIENTO)) || {}).analitica === true; } catch (e) { return false; }
};
const sesionDelPanel = () => {
    try { return clienteInfo() != null; } catch (e) { return false; }
};
const rutaDelPanel = () => /^\/(admin|auth)(\/|$)/i.test(window.location.pathname || "");
const permitido = () => consentimiento() && !sesionDelPanel() && !rutaDelPanel();
const codigoNormal = (c) => String(c || "").trim().toUpperCase();

// Si el cliente llego desde un anuncio de Meta (?fbclid=...), se recuerda en la sesion para atribuir la compra
// aunque navegue dentro de la pagina (React no recarga y el parametro se pierde de la URL).
try {
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    if (fbclid) sessionStorage.setItem(CLAVE_FBCLID, JSON.stringify({ fbclid, t: Date.now() }));
} catch (e) { /* sin sessionStorage */ }

// Pixeles configurados en el backend. Se piden una sola vez.
// { general: "id" | null, tiktokGeneral: "id" | null, eventos: { CODIGO: { meta: [ids], tiktok: [ids] } } }
const pixelesConfigurados = () => {
    if (!estado.config) {
        estado.config = AxioBoleteria.get("api/v1/meta/config")
            .then(({ data }) => {
                const eventos = {};
                Object.entries((data && data.eventos) || {}).forEach(([cod, p]) => {
                    const meta = (Array.isArray(p && p.meta) ? p.meta : []).map(String).filter((id) => ID_META.test(id));
                    const tiktok = (Array.isArray(p && p.tiktok) ? p.tiktok : []).map(String).filter((id) => ID_TIKTOK.test(id));
                    if (meta.length || tiktok.length) eventos[codigoNormal(cod)] = { meta, tiktok };
                });
                const general = data && data.activo && ID_META.test(String(data.pixelId)) ? String(data.pixelId) : null;
                const tiktokGeneral = data && ID_TIKTOK.test(String(data.tiktokPixelId || "")) ? String(data.tiktokPixelId) : null;
                return { general, tiktokGeneral, eventos };
            })
            .catch(() => ({ general: null, tiktokGeneral: null, eventos: {} }));
    }
    return estado.config;
};
const delEvento = (cfg, codigo) => cfg.eventos[codigoNormal(codigo)] || { meta: [], tiktok: [] };

// Codigo base oficial de Meta (fbevents.js), cargado de forma asincrona: no frena la pagina.
const cargarScriptMeta = () => {
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
    }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
};

// Codigo base oficial de TikTok, SIN cargar ningun pixel (cada uno se carga con ttq.load cuando hace falta)
const cargarScriptTiktok = () => {
    /* eslint-disable */
    !function (w, d, t) {
        if (w[t] && w[t].load) return;
        w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"], ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }; for (var i = 0; i < ttq.methods.length; i++)ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) {
            for (
                var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)ttq.setAndDefer(e, ttq.methods[n]); return e
        }, ttq.load = function (e, n) { var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner; ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {}; n = document.createElement("script"); n.type = "text/javascript", n.async = !0, n.src = r + "?sdkid=" + e + "&lib=" + t; e = document.getElementsByTagName("script")[0]; e.parentNode.insertBefore(n, e) };
    }(window, document, "ttq");
    /* eslint-enable */
};

const asegurarMeta = (id) => {
    if (typeof window.fbq !== "function") cargarScriptMeta();
    if (!estado.metaListo) { window.fbq("consent", "grant"); estado.metaListo = true; }
    if (!estado.metaIniciados.has(id)) {
        // Sin "eventos automaticos" de Meta; tiene que ir ANTES del init
        window.fbq("set", "autoConfig", false, id);
        window.fbq("init", id);
        estado.metaIniciados.add(id);
    }
};
const asegurarTiktok = (id) => {
    cargarScriptTiktok();
    if (!estado.tiktokIniciados.has(id)) {
        window.ttq.load(id);
        estado.tiktokIniciados.add(id);
    }
};

const limpiar = (datos) => {
    const limpio = {};
    Object.entries(datos || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "" && !(typeof v === "number" && isNaN(v))) limpio[k] = v; });
    return limpio;
};
const enviarMeta = (id, evento, datos, eventId) => {
    asegurarMeta(id);
    if (eventId) window.fbq("trackSingle", id, evento, limpiar(datos), { eventID: String(eventId) });
    else window.fbq("trackSingle", id, evento, limpiar(datos));
};
const enviarTiktok = (id, evento, datos, eventId) => {
    asegurarTiktok(id);
    const instancia = window.ttq.instance(id);
    if (evento === "page") { instancia.page(); return; }
    if (eventId) instancia.track(evento, limpiar(datos), { event_id: String(eventId) });
    else instancia.track(evento, limpiar(datos));
};

// Codigo del concierto de la URL de un anuncio: ?evento=CODIGO o #CODIGO
const codigoDeUrl = () => {
    try {
        return codigoNormal(new URLSearchParams(window.location.search).get("evento") || window.location.hash.replace("#", ""));
    } catch (e) { return ""; }
};

// Visita: PageView al pixel general y, si la URL es de un concierto, a sus pixeles (Meta y TikTok).
export const paginaVistaMeta = async () => {
    try {
        if (!permitido()) return false;
        const cfg = await pixelesConfigurados();
        if (!permitido()) return false;
        let envio = false;
        if (cfg.general) { enviarMeta(cfg.general, "PageView"); envio = true; }
        if (cfg.tiktokGeneral) { enviarTiktok(cfg.tiktokGeneral, "page"); envio = true; }
        const codigo = codigoDeUrl();
        if (codigo) {
            const p = delEvento(cfg, codigo);
            p.meta.filter((id) => id !== cfg.general).forEach((id) => { enviarMeta(id, "PageView"); envio = true; });
            p.tiktok.filter((id) => id !== cfg.tiktokGeneral).forEach((id) => { enviarTiktok(id, "page"); envio = true; });
        }
        if (envio) estado.iniciado = true;
        return envio;
    } catch (e) {
        return false;
    }
};

// Primera carga (por ejemplo, cuando el cliente acaba de aceptar las cookies)
export const iniciarMetaPixel = async () => {
    try {
        if (estado.iniciado) return true;
        return await paginaVistaMeta();
    } catch (e) {
        return false;
    }
};

// Evento al pixel general y a los del concierto (codigoEvento). tiktok: { evento, datos } para TikTok, o null.
export const eventoMeta = async (evento, datos = {}, eventId = null, codigoEvento = null, tiktok = null) => {
    try {
        if (!permitido()) return;
        const cfg = await pixelesConfigurados();
        if (!permitido()) return;
        const p = codigoEvento ? delEvento(cfg, codigoEvento) : { meta: [], tiktok: [] };
        const meta = [...new Set([cfg.general, ...p.meta].filter(Boolean))];
        if (evento) meta.forEach((id) => enviarMeta(id, evento, datos, eventId));
        if (tiktok) [...new Set([cfg.tiktokGeneral, ...p.tiktok].filter(Boolean))].forEach((id) => enviarTiktok(id, tiktok.evento, tiktok.datos, eventId));
    } catch (e) { /* nunca rompe la pagina */ }
};

// El cliente acepto o rechazo las cookies en el banner
export const actualizarConsentimientoMeta = (acepta) => {
    try {
        if (acepta) {
            if (estado.metaListo && typeof window.fbq === "function") window.fbq("consent", "grant");
            if (window.ttq && typeof window.ttq.grantConsent === "function") window.ttq.grantConsent();
            iniciarMetaPixel();
            return;
        }
        if (typeof window.fbq === "function") window.fbq("consent", "revoke");
        if (window.ttq && typeof window.ttq.revokeConsent === "function") window.ttq.revokeConsent();
    } catch (e) { /* nunca rompe la pagina */ }
};

const leerCookie = (nombre) => {
    try {
        const m = document.cookie.match(new RegExp("(?:^|; )" + nombre + "=([^;]*)"));
        return m ? decodeURIComponent(m[1]) : "";
    } catch (e) { return ""; }
};

// Datos para que el backend envie el Purchase cuando la compra quede pagada (se mandan al crear la compra).
// null si no hay pixel general ni del concierto, no hay permiso de cookies o es una venta del panel.
export const datosCompraMeta = async (codigoEvento = null) => {
    try {
        if (!permitido()) return null;
        const cfg = await pixelesConfigurados();
        const p = codigoEvento ? delEvento(cfg, codigoEvento) : { meta: [], tiktok: [] };
        if (!cfg.general && !cfg.tiktokGeneral && !p.meta.length && !p.tiktok.length) return null;
        let fbc = leerCookie("_fbc");
        if (!fbc) {
            const guardado = JSON.parse(sessionStorage.getItem(CLAVE_FBCLID) || "null");
            if (guardado && guardado.fbclid) fbc = `fb.1.${guardado.t}.${guardado.fbclid}`;
        }
        return { fbp: leerCookie("_fbp") || undefined, fbc: fbc || undefined, ttp: leerCookie("_ttp") || undefined, url: window.location.href };
    } catch (e) {
        return null;
    }
};

// ---------- Atajos con los datos de esta pagina ----------
const numero = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? Math.round(n * 100) / 100 : undefined;
};
const codigoDe = (evento) => String((evento && evento.codigoEvento) || "");

// El cliente abre un evento para comprar (para los pixeles del concierto tambien cuenta como visita a su pagina)
export const metaVerEvento = (evento) => {
    if (!evento) return;
    const codigo = codigoDe(evento);
    const datos = { content_ids: [codigo], content_name: evento.nombreConcierto, content_type: "product", currency: "USD" };
    (async () => {
        try {
            if (!permitido()) return;
            const cfg = await pixelesConfigurados();
            if (!permitido()) return;
            const p = delEvento(cfg, codigo);
            p.meta.filter((id) => id !== cfg.general).forEach((id) => enviarMeta(id, "PageView"));
            p.tiktok.filter((id) => id !== cfg.tiktokGeneral).forEach((id) => enviarTiktok(id, "page"));
        } catch (e) { /* nunca rompe la pagina */ }
    })();
    eventoMeta("ViewContent", datos, null, codigo, {
        evento: "ViewContent",
        datos: { contents: [{ content_id: codigo, content_name: evento.nombreConcierto }], content_type: "product", currency: "USD" },
    });
};

const contenidos = (codigo, lista) => lista.map((i) => ({ id: `${codigo || "evento"}-${i.localidad}`, quantity: parseInt(i.cantidad, 10) || 1 }));
const contenidosTiktok = (codigo, evento, lista) => lista.map((i) => ({
    content_id: `${codigo || "evento"}-${i.localidad}`, content_name: (evento && evento.nombreConcierto) || undefined,
    quantity: parseInt(i.cantidad, 10) || 1, price: numero(i.valor),
}));

// El cliente confirmo sus entradas y pasa a pagar. items: el carrito (getVerTienda)
export const metaIniciarCompra = (evento, items = []) => {
    const codigo = codigoDe(evento);
    const lista = Array.isArray(items) ? items.filter((i) => Number(i && i.cantidad) > 0) : [];
    const cantidad = lista.reduce((a, i) => a + (parseInt(i.cantidad, 10) || 0), 0);
    const valor = numero(lista.reduce((a, i) => a + (parseFloat(i.valor) || 0) * (parseInt(i.cantidad, 10) || 0), 0)) || undefined;
    const datos = {
        content_ids: [codigo], content_name: evento && evento.nombreConcierto, content_type: "product",
        contents: contenidos(codigo, lista), num_items: cantidad || undefined, value: valor, currency: "USD",
    };
    const tiktok = { contents: contenidosTiktok(codigo, evento, lista), content_type: "product", value: valor, currency: "USD" };
    eventoMeta("AddToCart", datos, null, codigo, { evento: "AddToCart", datos: tiktok });
    eventoMeta("InitiateCheckout", datos, null, codigo, { evento: "InitiateCheckout", datos: tiktok });
};

// El cliente eligio como pagar y se registra la compra
export const metaInfoPago = (metodo, total, evento) => {
    const codigo = codigoDe(evento);
    eventoMeta("AddPaymentInfo", { content_ids: [codigo], content_category: metodo, value: numero(total), currency: "USD" }, null, codigo, {
        evento: "AddPaymentInfo", datos: { contents: [{ content_id: codigo }], content_type: "product", value: numero(total), currency: "USD" },
    });
};

// La compra quedo registrada (todavia sin pagar). Solo TikTok: su "compra pagada" necesita la API de eventos
// de TikTok (token que no esta configurado). La compra pagada de Meta la envia el backend.
export const metaOrdenRegistrada = (evento, total, idCompra) => {
    const codigo = codigoDe(evento);
    eventoMeta(null, {}, idCompra ? `compra-${idCompra}` : null, codigo, {
        evento: "PlaceAnOrder", datos: { contents: [{ content_id: codigo, content_name: evento && evento.nombreConcierto }], content_type: "product", value: numero(total), currency: "USD" },
    });
};

// Registro de un cliente nuevo (solo pixeles generales: no es de un concierto)
export const metaRegistro = () => eventoMeta("CompleteRegistration", { status: true }, null, null, { evento: "CompleteRegistration", datos: {} });

// ---------- Compra pagada (mientras el cliente sigue en la pagina) ----------
const CLAVE_VIGILANCIA = "pixeles_compras_vigiladas";
const VIGILANCIA_MAX_MS = 30 * 60 * 1000;
const VIGILANCIA_MAX_COMPRAS = 5;
// 15 s los primeros 5 minutos (tarjeta / OCR suelen confirmarse rapido); despues, cada 60 s
const intervaloVigilancia = (edadMs) => (edadMs < 5 * 60 * 1000 ? 15000 : 60000);
const temporizadores = {};

const leerVigiladas = () => {
    try { const l = JSON.parse(sessionStorage.getItem(CLAVE_VIGILANCIA) || "[]"); return Array.isArray(l) ? l : []; } catch (e) { return []; }
};
const guardarVigiladas = (lista) => {
    try { sessionStorage.setItem(CLAVE_VIGILANCIA, JSON.stringify(lista)); } catch (e) { /* sin sessionStorage */ }
};
const dejarDeVigilar = (id) => {
    clearTimeout(temporizadores[id]);
    delete temporizadores[id];
    guardarVigiladas(leerVigiladas().filter((v) => String(v.id) !== String(id)));
};
const programarRevision = (id, ms) => {
    clearTimeout(temporizadores[id]);
    temporizadores[id] = setTimeout(() => { revisarCompra(id); }, ms);
};

// Avisa la compra pagada a los pixeles (generales y del concierto). Mismo id que usa el backend.
export const metaCompraPagada = (evento, total, idCompra) => {
    const codigo = codigoDe(evento);
    const valor = numero(total);
    eventoMeta("Purchase", {
        content_ids: [codigo], content_name: evento && evento.nombreConcierto, content_type: "product",
        value: valor, currency: "USD", order_id: idCompra ? String(idCompra) : undefined,
    }, idCompra ? `compra-${idCompra}` : null, codigo, {
        evento: "CompletePayment",
        datos: { contents: [{ content_id: codigo, content_name: evento && evento.nombreConcierto }], content_type: "product", value: valor, currency: "USD" },
    });
};

const revisarCompra = async (id) => {
    const v = leerVigiladas().find((x) => String(x.id) === String(id));
    if (!v) return;
    const edad = Date.now() - Number(v.inicio || 0);
    if (edad > VIGILANCIA_MAX_MS || !permitido()) { dejarDeVigilar(id); return; }
    // Pestana en segundo plano: no se consulta (se vuelve a intentar mas tarde)
    if (typeof document !== "undefined" && document.visibilityState === "hidden") { programarRevision(id, intervaloVigilancia(edad)); return; }
    try {
        const { data } = await AxioBoleteria.get(`api/v1/meta/estado_compra/${encodeURIComponent(id)}`, { params: { cedula: v.cedula } });
        if (data && data.encontrada && data.pagado) {
            dejarDeVigilar(id);
            metaCompraPagada({ codigoEvento: v.codigoEvento, nombreConcierto: v.nombre }, v.total, id);
            return;
        }
        if (data && (data.encontrada === false || data.cerrada)) { dejarDeVigilar(id); return; }
    } catch (e) { /* sin conexion: se reintenta */ }
    programarRevision(id, intervaloVigilancia(edad));
};

// Empieza a vigilar una compra recien registrada (o con comprobante recien subido). inmediato: primera consulta en 2 s
// (la transferencia aprobada por el OCR ya esta pagada al terminar de subir el comprobante).
export const vigilarPagoCompra = ({ idCompra, cedula, total, evento, inmediato = false } = {}) => {
    try {
        if (!permitido() || !idCompra || !String(cedula || "").trim()) return;
        const lista = leerVigiladas().filter((x) => String(x.id) !== String(idCompra));
        const nueva = { id: String(idCompra), cedula: String(cedula).trim(), total: numero(total) || 0,
            codigoEvento: codigoDe(evento), nombre: (evento && evento.nombreConcierto) || "", inicio: Date.now() };
        guardarVigiladas([...lista, nueva].slice(-VIGILANCIA_MAX_COMPRAS));
        programarRevision(nueva.id, inmediato ? 2000 : 15000);
    } catch (e) { /* nunca rompe la pagina */ }
};

// Si el cliente recarga la pagina, se retoman las compras que seguian pendientes (dentro de los 30 minutos)
try {
    leerVigiladas().forEach((v) => {
        if (Date.now() - Number(v.inicio || 0) < VIGILANCIA_MAX_MS) programarRevision(v.id, 3000);
        else dejarDeVigilar(v.id);
    });
} catch (e) { /* sin sessionStorage */ }
